<template>
    <div class="announcements" :class="{ 'announcements--controls': prefersReducedMotion && announcementCount > 1 }">
        <div class="announcements__controls" v-if="prefersReducedMotion && announcementCount > 1">
            <button
                type="button"
                class="announcements__control"
                aria-controls="announcements"
                aria-label="Play Announcements Marquee"
                v-show="!isPlaying"
                @click="play"
            ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19">
                <path fill="currentColor" d="M15.15757 7.69898 2.58579.26663C1.56433-.33696 0 .24877 0 1.74167V16.6028c0 1.33932 1.45361 2.14649 2.58579 1.47504l12.57178-7.42878c1.12146-.66073 1.12503-2.28935 0-2.95008Zm-.5786 1.96791L2.0072 17.09567c-.37858.21786-.86431-.04286-.86431-.49287V1.74167c0-.58216.58573-.65716.86074-.49287L14.5754 8.68115c.375.22144.375.7643.00357.98574Z"/>
            </svg></button>
            <button
                type="button"
                v-show="isPlaying"
                class="announcements__control"
                aria-controls="announcements"
                aria-label="Pause Announcements Marquee"
                @click="pause"
            ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path fill="currentColor" d="M1.71429 16h3.42857c.94643 0 1.71428-.76786 1.71428-1.71429V1.7143C6.85714.76786 6.0893 0 5.14286 0H1.71429C.76786 0 0 .76786 0 1.71429V14.2857C0 15.23214.76786 16 1.71429 16ZM1.14286 1.71429c0-.31429.25714-.57143.57143-.57143h3.42857c.31428 0 .57143.25714.57143.57143V14.2857c0 .31429-.25715.57143-.57143.57143H1.71429c-.31429 0-.57143-.25714-.57143-.57143V1.7143ZM10.85714 16h3.42857C15.23214 16 16 15.23214 16 14.28571V1.7143C16 .76786 15.23214 0 14.28571 0h-3.42857c-.94643 0-1.71428.76786-1.71428 1.71429V14.2857c0 .94643.76785 1.71429 1.71428 1.71429Zm-.57143-14.28571c0-.31429.25715-.57143.57143-.57143h3.42857c.31429 0 .57143.25714.57143.57143V14.2857c0 .31429-.25714.57143-.57143.57143h-3.42857c-.31428 0-.57143-.25714-.57143-.57143V1.7143Z"/>
            </svg></button>
        </div>
        <div class="announcements__track">
            <div id="announcements" class="announcements__scroller" role="marquee" aria-label="Announcements" tabindex="0" :style="trackStyle">
                <div
                    class="announcements__item"
                    role="region"
                    tabindex="0"
                    v-for="(announcement, index) in announcements"
                    :key="index"
                    :aria-current="currentAnnouncement === index"
                >
                    <div class="announcements__content">
                        <span v-html="breakpoint !== 'phone' ? announcement.html_content : announcement.html_content_mobile"></span>
                        <a :href="announcement.url" v-if="announcement.url && announcement.link">{{ announcement.link }}</a>
                    </div>
                </div>

                <!-- Duplicate of first announcment for infinite looping -->
                <div class="announcements__item" aria-hidden="true" tabindex="-1">
                    <div class="announcements__content">
                        <span v-html="breakpoint !== 'phone' ? announcements[0].html_content : announcements[0].html_content_mobile"></span>
                        <a :href="announcements[0].url" v-if="announcements[0].url && announcements[0].link">{{ announcements[0].link }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        announcements: { type: Array, required: true },
        playTrigger: { type: Boolean, default: true }
    },
    data: () => ({
        root: undefined,
        prefersReducedMotion: matchMedia('(prefers-reduced-motion: reduce)').matches,
        isPlaying: false,
        width: window.innerWidth,
        height: 0,
        resizeObserver: undefined,
        tickerTimeout: undefined,
        animationDuration: 2000,
        pauseDuration: 10000,
        currentAnnouncement: 0,
    }),
    computed: {
        breakpoint() {
            return this.$parent.currentBreakpoint;
        },
        translate() {
            return this.width * this.currentAnnouncement;
        },
        trackStyle() {
            return {
                transition: this.currentAnnouncement === 0
                    ? 'none'
                    : `transform ${this.animationDuration}ms ease-in-out`,
                transform: `translateX(-${this.width * this.currentAnnouncement}px)`,
            };
        },
        announcementCount() {
            return this.announcements.length;
        }
    },
    watch: {
        playTrigger(shouldPlay) {
            if (shouldPlay) {
                this.pause();
                this.currentAnnouncement = 0;
                this.play();
            } else {
                this.pause();
            }
        }
    },
    mounted() {
        console.log(this.announcements);
        this.root = document.documentElement;
        this.updateCssHeaderHeightVariables();
        this.resizeObserver = new ResizeObserver(this.handleResizeFunc);
        this.resizeObserver.observe(this.$el);
        if (!this.prefersReducedMotion && this.announcementCount > 1 && this.playTrigger) {
            this.play();
        } else {
            this.width = window.innerWidth - 32;
        }
    },
    beforeDestroy() {
        if (this.ticker) {
            cancelAnimationFrame(this.ticker);
        }
        if (this.tickerTimeout) {
            clearTimeout(this.tickerTimeout);
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },

    methods: {
        updateCssHeaderHeightVariables() {
            let navHeight = getComputedStyle(this.root).getPropertyValue('--navHeight');
            let superNavHeight = getComputedStyle(this.root).getPropertyValue('--superNavHeight');

            navHeight = navHeight ? parseInt(navHeight.replace('px'), 10) : 0;
            superNavHeight = superNavHeight ? parseInt(superNavHeight.replace('px'), 10) : 0;

            const nav = document.querySelector('.main-nav').clientHeight;
            this.root.style.setProperty('--headerHeight', this.height + nav + 'px');

            // if (this.breakpoint !== 'phone') {
            //     this.root.style.setProperty('--headerHeight', this.height + nav + 'px');
            // } else {
            //     this.root.style.setProperty('--headerHeight', navHeight + superNavHeight + 'px')
            // }
        },
        handleResizeFunc(entries) {
            entries.forEach(entry => {
                this.width = entry.contentBoxSize
                    ? (entry.contentBoxSize[0] ? entry.contentBoxSize[0].inlineSize : entry.contentBoxSize.inlineSize)
                    : entry.contentRect.width;
                this.height = entry.contentBoxSize
                    ? (entry.contentBoxSize[0] ? entry.contentBoxSize[0].blockSize : entry.contentBoxSize.blockSize)
                    : entry.contentRect.height;

                if (this.prefersReducedMotion) {
                    this.width -= 32;
                }
                this.updateCssHeaderHeightVariables();
            });
        },
        animate() {
            this.currentAnnouncement = this.currentAnnouncement === this.announcementCount ? 0 : this.currentAnnouncement + 1;
            this.play();
        },
        play() {

            this.isPlaying = true;

            if (this.tickerTimeout) {
                clearTimeout(this.tickerTimeout);
            }

            if (this.currentAnnouncement === 0) {
                this.tickerTimeout = setTimeout(this.animate, this.pauseDuration);
            } else if (this.currentAnnouncement !== this.announcementCount) {
                this.tickerTimeout = setTimeout(this.animate, this.animationDuration + this.pauseDuration)
            } else {
                this.tickerTimeout = setTimeout(this.animate, this.animationDuration);
            }
        },
        pause() {
            this.isPlaying = false;
            if (this.tickerTimeout) {
                clearTimeout(this.tickerTimeout);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/announcements.vue